/* eslint-disable max-lines-per-function */
import "./review-pie-chart.scss";

const getCoordinatesForPercent = percent => {
  const x = Math.cos(2 * Math.PI * percent);
  const y = Math.sin(2 * Math.PI * percent);
  return [x, y];
};

const normalize = initialData => {
  const { data } = initialData.reduce(
    (acct, { value }, index) => {
      const total = acct.total + value;
      const isLast = index === initialData.length - 1;
      const val = { value: isLast ? 100 - total + value : value };
      return {
        total,
        data: [...acct.data, val]
      };
    },
    { total: 0, data: [] }
  );
  return data;
};

export default () => {
  Array.from(document.querySelectorAll(".js-review-pie-chart-svg")).forEach(svgEl => {
    const data = normalize(JSON.parse(svgEl.getAttribute("data-chart")));
    const colors = JSON.parse(svgEl.getAttribute("data-colors"));
    const slices = data.map((d, index) => ({
      percent: d.value / 100,
      color: colors[index]
    }));
    let cumulativePercent = 0;

    slices.forEach(slice => {
      const [startX, startY] = getCoordinatesForPercent(cumulativePercent);
      cumulativePercent += slice.percent;
      const [endX, endY] = getCoordinatesForPercent(cumulativePercent);

      const largeArcFlag = slice.percent > 0.5 ? 1 : 0;

      const pathData = [
        `M ${startX} ${startY}`, // Move
        `A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY}`, // Arc
        `L 0 0` // Line
      ].join(" ");

      const pathEl = document.createElementNS("http://www.w3.org/2000/svg", "path");
      pathEl.setAttribute("d", pathData);
      pathEl.setAttribute("fill", slice.color);
      svgEl.appendChild(pathEl);
    });
  });
};
